import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { ApplicationOutputDTO, ApplicationByClientOutputDTO } from './applicationDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class ApplicationServices {
  async getById(id: number): Promise<ApplicationOutputDTO> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/application/${id}`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getByAll(): Promise<ApplicationOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/application`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getApplicationByClient(id: number): Promise<ApplicationByClientOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_AUTH}/applicationByClient/client/${id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}

export const applicationServices = new ApplicationServices()
